






import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    priority: {
      type: String as PropType<Props["priority"]>,
      default: "1",
      validator: function(value) {
        return ["1", "2", "3", "4", "5"].includes(value);
      }
    }
  },
  computed: {
    priorityClass() {
      const priorityClass: { [s: string]: boolean } = {};
      priorityClass[`heading--${this.priority}`] = true;
      return priorityClass;
    },
    tagName() {
      return `h${this.priority}`;
    }
  }
});
